import type { Directive, DirectiveBinding } from 'vue'

import Inputmask from 'inputmask'

export const inputmask: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    if (el.tagName !== 'INPUT') {
      console.error('The inputmask directive can only be used on input elements')
      return
    }

    let options: Inputmask.Options = {
      showMaskOnHover: false,
      showMaskOnFocus: false,
      clearIncomplete: true,
    }

    // Handle different binding formats
    if (binding.value) {
      if (typeof binding.value === 'string') {
        // Direct string mask: v-mask="99-9999999"
        options.mask = binding.value
      } else if (typeof binding.value === 'object') {
        // Object with options: v-mask="{'mask': '99-9999999'}" or v-mask="{'alias': 'datetime'}"
        options = { ...options, ...binding.value }
      }
    }

    const mask = new Inputmask(options)
    mask.mask(el)
  },

  // Handle updates to the directive value
  updated(el: HTMLElement, binding: DirectiveBinding) {
    if (el.tagName !== 'INPUT') return

    // Only update if the value has changed
    if (binding.oldValue !== binding.value) {
      // Remove the old mask
      Inputmask.remove(el)

      // Apply the new mask with the same logic as in mounted
      let options: Inputmask.Options = {
        showMaskOnHover: false,
        showMaskOnFocus: false,
        clearIncomplete: true,
      }

      if (binding.value) {
        if (typeof binding.value === 'string') {
          options.mask = binding.value
        } else if (typeof binding.value === 'object') {
          options = { ...options, ...binding.value }
        }
      }

      const mask = new Inputmask(options)
      mask.mask(el)
    }
  },

  // Clean up when the directive is unbound
  unmounted(el: HTMLElement) {
    if (el.tagName === 'INPUT') {
      Inputmask.remove(el)
    }
  },
}
